// @ts-nocheck
import { Button, Card, Paper, Typography } from "@mui/material";
import React from "react";
import { HostTerminalCommand } from "./terminalCommands";

function TerminalCommandEntry(props: {
  command: HostTerminalCommand;
  onDeletePressed: (id: string) => void;
  onRefreshPressed: (id: string) => void;
}) {
  return (
    <Paper elevation={3}>
      <div style={{ margin: "10px" }}>
        <Typography variant={"h5"}>Terminal Command</Typography>
        <br />
        <Typography>ID: {props.command._id}</Typography>
        <Typography>
          Type: <b>{props.command.commandType}</b>
        </Typography>
        <Typography>
          Parameters: {JSON.stringify(props.command.parameters)}
        </Typography>
        <Typography>Sent: {props.command.sent.toString()}</Typography>
        <Typography>Created at: {props.command.createdAt}</Typography>
        <Typography>Last Updated: {props.command.updatedAt}</Typography>
        <Typography>
          Response:{" "}
          {props.command.response
            ? JSON.stringify(props.command.response)
            : "None"}
        </Typography>
        <Typography>
          Response Time: {props.command.responseTimestamp || "None"}
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            props.onRefreshPressed(props.command._id);
          }}
        >
          Refresh Data
        </Button>
        <br />
        <br />
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            props.onDeletePressed(props.command._id);
          }}
        >
          Delete Command
        </Button>

        <br />
      </div>
    </Paper>
  );
}

export default TerminalCommandEntry;
